export default {
  state: {
    selectedPage: null,
  },
  getters: {},
  mutations: {
    setSelectedPage(state, page) {
      state.selectedPage = page
    }
  },
  actions: {}
}


// WEBPACK FOOTER //
// ./src/vuex/modules/security.js